import { get } from '../../Common/utils';

import { dropDownDefault } from './constants';

const normalizeAggregators = (aggregators = []) =>
  dropDownDefault.concat(
    aggregators.map(aggregator => ({
      label: get(aggregator, 'aggregatorID', ''),
      value: get(aggregator, 'aggregatorID', ''),
    })),
  );

const normalizePayers = (payers = []) =>
  dropDownDefault.concat(
    payers.map(payer => {
      const id = get(payer, 'payerID', '');

      return {
        label: id ? `${get(payer, 'payerName', '')} (${id})` : '',
        value: id,
      };
    }),
  );

const normalizeExceptions = (exceptions = []) =>
  exceptions.map(exception => ({
    exceptionCode: get(exception, 'exceptionCode', ''),
    exceptionCodeAggregator: get(exception, 'exceptionCodeAggregator', ''),
    description: get(exception, 'description', ''),
  }));

export { normalizeAggregators, normalizePayers, normalizeExceptions };
